export const mapLocaleLang = (value: string): string => {
    switch (value) {
        case 'ko':
            return '-ko';
        case 'zh-Hans':
            return '-cn';
        case 'fr-CA':
            return '-fr-ca';
        case 'fr-FR':
        case 'fr':
            return '-fr';
        case 'es':
            return '-esp';
        case 'ja':
            return '-ja';
        default:
            return '';
    }
};
